(function () {
  var SELECTOR = '[data-hmx-customer-city]';
  var CACHE_KEY = 'hmx_customer_city';

  function targets() {
    var elements = document.querySelectorAll(SELECTOR);
    var matches = [];
    for (var i = 0; i < elements.length; i++) {
      var value = (elements[i].textContent || '').trim().toLowerCase();
      if (value === 'your area' || elements[i].getAttribute('data-hmx-city') === 'true') {
        matches.push(elements[i]);
      }
    }
    return matches;
  }

  function setCity(city) {
    if (!city) return;
    var elements = targets();
    for (var i = 0; i < elements.length; i++) {
      elements[i].textContent = city;
      elements[i].setAttribute('data-hmx-city', 'true');
    }
  }

  function cachedCity() {
    try {
      return sessionStorage.getItem(CACHE_KEY);
    } catch (error) {
      return null;
    }
  }

  function saveCity(city) {
    try {
      sessionStorage.setItem(CACHE_KEY, city);
    } catch (error) {
      // Keep the fallback when storage is unavailable.
    }
  }

  function loadCity() {
    if (!targets().length) return;

    var cached = cachedCity();
    if (cached) {
      setCity(cached);
      return;
    }

    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = controller ? setTimeout(function () {
      controller.abort();
    }, 3000) : null;

    fetch('https://ipwho.is/', {
      method: 'GET',
      credentials: 'omit',
      signal: controller ? controller.signal : undefined
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Location lookup failed');
        return response.json();
      })
      .then(function (data) {
        if (data && typeof data.city === 'string' && data.city.trim()) {
          var city = data.city.trim();
          saveCity(city);
          setCity(city);
        }
      })
      .catch(function () {
        // "your area" remains visible when location is unavailable.
      })
      .finally(function () {
        if (timeout) clearTimeout(timeout);
      });
  }

  function schedule() {
    setTimeout(loadCity, 350);
  }

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule, { once: true });
  }

  document.addEventListener('shopify:section:load', loadCity);
})();